import http from 'services/http';

import { PortalConnectionBlocker } from './portalConnections';

/**
 * Starting Portal Scans from the web app (OLIO-3023).
 *
 * Deliberately NOT `POST /api/workflows`: that endpoint permits no `external_id`, so a sweep
 * created through it would bypass the api's one-live-sweep-per-portal singleton, and the caller
 * would have to guess the coordinating group. This endpoint reuses the same creation path the
 * platform's START_PORTAL_DISCOVERY task takes.
 *
 * The portals themselves come from `GET /api/portal_connections` — those rows already carry
 * `canScan` and `scanBlockers`, so the modal needs no list endpoint of its own.
 */

// One requested portal's outcome. Three distinguishable results, and the difference matters:
//
//   created: true                      — a scan started
//   created: false, workflowId set     — this portal ALREADY had a live scan; the request joined
//                                        it rather than starting a second one
//   created: false, workflowId null    — refused, and `blockers` says why
//
// The middle case is the one a multi-select makes routine, and the one that reads as a bug if it
// is reported as "started".
export interface PortalScanResult {
  sourceSystem: string;
  workflowId: string | null;
  created: boolean;
  blockers: PortalConnectionBlocker[];
}

export async function startPortalScans(sourceSystems: string[]) {
  return http.post<{ data: PortalScanResult[] }>('portal_scans', { sourceSystems }).then((res) => res.data.data ?? []);
}
